import {useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import {useNavigateWithReload} from "base/hooks";
import {AuthAction} from "base/auth";
import {SidebarPanelLayout} from "base/layout";
import {
    AlertError,
    DeleteItemDialog,
    SectionCard,
    SidebarAction,
} from "base/component/presentational";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import LaunchIcon from "@mui/icons-material/Launch";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

const EntityViewPanel = ({
    children,
    title,
    onClickConnectionsAsOrigen = null,
    onClickConnectionsAsDestino = null,
    showDetailButton = true,
    onClickDetailButton = null,
    showEditAction = false,
    onClickEditAction = null,
    showDeleteAction = false,
    onClickDeleteAction = null,
    deleteService = null,
}) => {
    const {idInfoPanel} = useParams();
    const navigate = useNavigateWithReload();

    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [error, setError] = useState("");

    const location = useLocation();
    const basePath = location.pathname.split("info/")[0];

    const handleClose = () => {
        console.log({basePath});
        navigate(`${basePath}`);
    };

    const handleClickDetail = () => {
        if (onClickDetailButton) {
            onClickDetailButton(idInfoPanel);
        } else {
            navigate(`${basePath}/${idInfoPanel}`);
        }
    };

    const handleClickEdit = () => {
        if (onClickEditAction) {
            onClickEditAction(idInfoPanel);
        } else {
            navigate(`${basePath}/${idInfoPanel}/edit`);
        }
    };

    const handleClickDelete = () => {
        setIsDeleteDialogOpen(true);
    };

    const handleDelete = () => {
        if (onClickDeleteAction) {
            onClickDeleteAction(idInfoPanel);
        } else if (deleteService) {
            deleteService(idInfoPanel)
                .then(() => {
                    navigate(basePath, true);
                })
                .catch(error => {
                    setError(error);
                });
        }
    };

    const sidebarActions = [];

    if (showDeleteAction) {
        sidebarActions.push(
            <AuthAction
                key="remove-entity"
                roles={[]} // TODO: Bootstraped permissions
            >
                <SidebarAction
                    name="remove-entity"
                    text="Eliminar"
                    icon={<DeleteIcon color="error" />}
                    onClick={() => handleClickDelete()}
                />
            </AuthAction>
        );
    }

    if (onClickConnectionsAsOrigen) {
        sidebarActions.push(
            <AuthAction
                key="manage-connections-origen"
                roles={[]} // TODO: Bootstraped permissions
            >
                <SidebarAction
                    name="manage-connections-origen"
                    text="Xestionar conexións dende este elemento"
                    icon={<AccountTreeIcon />}
                    onClick={onClickConnectionsAsOrigen}
                />
            </AuthAction>
        );
    }
    if (showEditAction) {
        sidebarActions.push(
            <AuthAction
                key="edit-entity"
                roles={[]} // TODO: Bootstraped permissions
            >
                <SidebarAction
                    name="edit-entity"
                    text="Modificar"
                    icon={<EditIcon />}
                    onClick={() => handleClickEdit()}
                />
            </AuthAction>
        );
    }

    if (onClickConnectionsAsDestino) {
        sidebarActions.push(
            <AuthAction
                key="manage-connections-destino"
                roles={[]} // TODO: Bootstraped permissions
            >
                <SidebarAction
                    name="manage-connections-destino"
                    text="Xestionar conexións cara este elemento"
                    icon={<AccountTreeIcon sx={{transform: "rotate(180deg)"}} />}
                    onClick={onClickConnectionsAsDestino}
                />
            </AuthAction>
        );
    }

    return (
        <SidebarPanelLayout
            sidebarTitle={title}
            closeSidebarClick={handleClose}
            sidebarActions={sidebarActions.length > 0 ? sidebarActions : null}
        >
            <AlertError error={error} />
            {children}

            {(onClickConnectionsAsOrigen || onClickConnectionsAsDestino) && (
                <SectionCard title="Xestionar conexións">
                    {onClickConnectionsAsOrigen && (
                        <Grid container justifyContent="center" sx={{mb: 2}}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={onClickConnectionsAsOrigen}
                                startIcon={<AccountTreeIcon />}
                            >
                                Conexións dende este elemento
                            </Button>
                        </Grid>
                    )}
                    {onClickConnectionsAsDestino && (
                        <Grid container justifyContent="center">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={onClickConnectionsAsDestino}
                                startIcon={
                                    <AccountTreeIcon
                                        sx={{transform: "rotate(180deg)"}}
                                    />
                                }
                            >
                                Conexións cara este elemento
                            </Button>
                        </Grid>
                    )}
                </SectionCard>
            )}

            {showDetailButton && (
                <Grid container justifyContent="center" sx={{mt: 2}}>
                    <Button
                        variant="contained"
                        color="inherit"
                        sx={{ml: 3}}
                        onClick={handleClickDetail}
                        startIcon={<LaunchIcon />}
                    >
                        Ver detalle
                    </Button>
                </Grid>
            )}
            <DeleteItemDialog
                isDialogOpen={isDeleteDialogOpen}
                setIsDialogOpen={setIsDeleteDialogOpen}
                onDelete={handleDelete}
            />
        </SidebarPanelLayout>
    );
};

export default EntityViewPanel;
